import { advanceTask } from './advanceTask'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, registerJob } from './jobs'
import { createTask_build } from './taskBuild'
import { createConsumeCargoTask } from './taskConsumeCargo'
import { createTask_deliverCargo } from './taskDeliverCargo'
import { createFetchCargoTask } from './taskFetchCargo'

export const register = () => registerJob('build', advanceJob_build)

export function advanceJob_build(job: IJob) {
  jobLogger.assertJobType(job, 'build')

  let bp = jobLogger.assertBlueprint(job)
  let m = jobLogger.assertReserved(job)

  // Seed job tasks
  if (job.tasks.length === 0) {
    job.isFailed = false
    job.tasks = []

    // Get cargo
    let task = createFetchCargoTask(m.i, m.j, null, 'steel', true)
    job.tasks.push(task)

    // Go to blueprint
    task = createTask_deliverCargo(bp.i, bp.j, 'steel', true)
    job.tasks.push(task)

    // Construct
    task = createConsumeCargoTask(bp.i, bp.j, 'steel')
    job.tasks.push(task)
    task = createTask_build(bp.i, bp.j)
    job.tasks.push(task)

    return
  }

  if (job.tasks.length > 0) {
    advanceTask(job)
  }
}
